import { registerAction } from '../../../Action'
import decorators from '../../../jsonApiParser/decorators'

const LOAD_CONTENT = 'LOAD_CONTENT'

const reducer = (state = {}, action) => {
  const decoratedContent = decorators.contents(action.payload)
  return {
    ...state,
    content: decoratedContent,
    content_loaded: true,
  }
}

const loadContent = registerAction(LOAD_CONTENT, { reducer })

export default loadContent
